import React from "react"
import ShowMoreText from "react-show-more-text"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function VenueDescriptionWithShowMore(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { venue } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  // if no description use standard copy
  if (!venue.description || venue.description.length === 0) {
    let categories = venue.venue_categories.map((el, index) => {
      return (index === 0 ? "" : " ") + el.name
    })
    return (
      <p>
        {I18n.t("pages.venues.show.venue_details.default_description", {
          venue_name: venue.name,
          venue_categories: categories,
        })}
      </p>
    )
  } else {
    return (
      <ShowMoreText
        lines={3}
        more={I18n.t("pages.venues.show.venue_details.show_more")}
        less={I18n.t("pages.venues.show.venue_details.show_less")}
        anchorClass={style.showMore}
        expanded={false}
        keepNewLines={true}
      >
        {venue.description}
      </ShowMoreText>
    )
  }
}

// ----------------------------------------------------------------------------

export default VenueDescriptionWithShowMore
